<template>
  <div class="file-input" data-cy="file-input">
    <div v-if="selectedFiles?.length" class="flex" data-cy="file-selected">
      <Button
        v-if="showCancelButton"
        class="p-button-danger mr-2"
        data-cy="cancel-button"
        @click="resetInput"
      >
        Cancel
      </Button>
      <div>
        <p
          v-for="file in selectedFiles"
          :key="file.name"
          data-cy="selected-file"
        >
          {{ file.name }}
        </p>
      </div>
    </div>
    <Button
      v-else
      class="p-button-success"
      data-cy="add-file-button"
      @click="inputEl?.click()"
    >
      <i :class="icon"></i>
      <span class="ml-1">{{ label }}</span>
    </Button>

    <input
      ref="inputEl"
      type="file"
      accept=".xlsx"
      data-cy="file-input-element"
      @change="onChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  icon: {
    type: String,
    default: "far fa-file-import"
  },
  label: {
    type: String,
    default: "Add File"
  },
  showCancelButton: {
    type: Boolean,
    default: false
  },
  instantReset: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits<{
  (e: "change", event: Event): void;
}>();

const inputEl = ref<HTMLInputElement | null>(null);
const selectedFiles = ref<FileList | null>(null);

function onChange(event: Event) {
  const target = event.target as HTMLInputElement | null;
  if (target) {
    const files = target.files;
    selectedFiles.value = files;
  }

  emit("change", event);

  if (props.instantReset) {
    resetInput();
  }
}

function resetInput() {
  if (inputEl.value) {
    inputEl.value.value = "";
    selectedFiles.value = null;
  }
}
</script>

<style lang="scss" scoped>
.file-input {
  display: flex;
  input[type="file"] {
    display: none;
  }
}
</style>
